import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { marker as t } from '@biesbjerg/ngx-translate-extract-marker';
import { ColumnMode } from '@swimlane/ngx-datatable';

import { GlobalConstant } from '@constants/global.constant';
import { OrderStatusEnum, OrderStatusEnumType } from '@enums/order-status.enum';
import { TranslateService } from '@ngx-translate/core';
import { DateService } from '@shared/services/date/date.service';
import { OrderOptionsColumns } from './orders-table.interface';
import { OrderListItem } from '@pages/common-order/_interfaces_/order.interface';
import { OrderIconsEnum } from '@enums/order-icons.enum';

@Component({
  selector: 'app-orders-table',
  templateUrl: './orders-table.component.html',
  styleUrls: ['./orders-table.component.scss'],
})
export class OrdersTableComponent {
  @Input() orders: OrderListItem[];
  @Input() loading: boolean;
  @Output() onOrderClick = new EventEmitter<OrderListItem>();
  ColumnMode = ColumnMode;
  columns: OrderOptionsColumns = {
    orderStatus: { name: t('OVERVIEW.ORDER_STATUS'), prop: 'status' },
    orderNumber: { name: t('OVERVIEW.ORDER_NUMBER'), prop: 'orderNumber' },
    pnr: { name: t('OVERVIEW.REFERENCE'), prop: 'pnr' },
    name: { name: t('OVERVIEW.NAME'), prop: 'mainPassengerName' },
    destination: { name: t('OVERVIEW.DESTINATION'), prop: 'endDestination' },
    departureDate: { name: t('OVERVIEW.DEPARTURE'), prop: 'departureDate' },
  };

  constructor(
    @Inject(GlobalConstant) private _globalConstant: GlobalConstant,
    @Inject(DateService) private _dateService: DateService,
    @Inject(TranslateService) private _translateService: TranslateService
  ) {}

  orderStatusComparator = (aOrderStatus: OrderStatusEnumType, bOrderStatus: OrderStatusEnumType): -1 | 0 | 1 => {
    if (aOrderStatus < bOrderStatus) {
      return -1;
    }
    if (aOrderStatus > bOrderStatus) {
      return 1;
    }
    return 0;
  };

  departureDateComparator = (aCol: string, bCol: string, aRow: OrderListItem, bRow: OrderListItem): number => {
    return this._dateService.dateComparator(new Date(aRow.departureDate), new Date(bRow.departureDate));
  };

  onActivate(e: any): void {
    if (e.type === 'click') {
      this.onRowClick(e.row);
    }
  }

  onRowClick(row: OrderListItem): void {
    this.onOrderClick.emit(row);
  }

  isBookedStatus(status: string): boolean {
    return status === OrderStatusEnum.BOOKED;
  }

  get tableCssClasses(): any {
    return this._globalConstant.dataTable.defaultCSSClasses;
  }

  get hasOrderOptions(): boolean {
    return this.orders && this.orders.length > 0;
  }

  get locale(): string {
    return this._translateService.currentLang;
  }

  showWarningIcon(row: OrderListItem): boolean {
    return row.optionIcon === OrderIconsEnum.Warning;
  }
}
